<template>
  <div>
    <Row>
      <Form ref="queryPlanForm" :model="query" :label-width="70"  label-position="right" inline class="index-query-form">
        <Input
          v-model="query.plateNo"
          placeholder="请输入车牌号"
          style="width:150px;margin-right: 10px;"
        />
        <Input
          v-model="query.box"
          placeholder="请输入箱号"
          style="width:150px;margin-right: 10px;"
        />
        <Input
          v-model="query.goodsName"
          placeholder="请输入货物名"
          style="width:150px;margin-right: 10px;"
        />
        <Input
          v-model="query.channel"
          placeholder="请输入通道编号"
          style="width:150px;margin-right: 10px;"
        />
        <Select v-model="query.creator" filterable style="width:150px;margin-right: 10px;" placeholder="请选择创建人">
          <Option v-for="item in list.data" :value="item.id" :key="item.id">{{ item.username }}</Option>
        </Select>
        <Date-picker :value="query.createTime" type="date" @on-change="setTimeFormat"
                     placeholder="请输入创建时间"></Date-picker>
        <Form-item :label-width="0">
          <span @click="handleSearch" style="margin: 0 10px;"><Button type="primary" >{{$t('searchText')}}</Button></span>
          <Button @click="resetSearchForm" type="default" >{{$t('resetText')}}</Button>
        </Form-item>
        <Button @click="openPlanDrawer()" type="primary" style="margin-right: 10px;float:right" >{{$t('newText')}}</Button>
      </Form>
    </Row>
    <Row v-loading="page.loading" class="margin-top-10  searchable-table-con1"  style="width:100%;">
      <Table ref="planTable" :columns="columns" stripe border :data="page.data" @on-sort-change="handlePageSortChange"></Table>
      <Row v-if="page.total>0" type="flex" justify="space-between" align="middle" >
        <div>
          <Select v-model="batchOperate.action" placeholder="请选择" style="width:120px;margin-right: 10px;">
            <Option v-for="item in batchOperate.options" :key="item.value" :label="item.label" :value="item.value"></Option>
          </Select>
          <Button type="primary" :disabled="this.batchOperate.action=='' || $refs.planTable.getSelection().length == 0"
                  :loading="batchOperate.submiting"
                  @click="handleBatchOperate">
            {{ batchOperate.submiting ? '提交中 ...' : '确 定' }}</Button>
        </div>
        <Page :current="page.current" :total="page.total"  :page-size="page.size" @on-change="handlePageChange" show-elevator show-total style="padding: 10px;"></Page>
      </Row>
    </Row>
    <el-drawer ref="planDrawer" :title="this.$t('drawer.title')[planDrawer.type]" :visible.sync="planDrawer.visible" direction="rtl" size="40%" custom-class="right-drawer">
      <div class="right-drawer__content">
        <plan-form ref="planForm"/>
        <div class="right-drawer__footer" v-if="planDrawer.type!='detail'">
          <Button type="primary" @click="handleSubmit()" :loading="planDrawer.submiting">{{ planDrawer.submiting ? '提交中 ...' : '保 存' }}</Button>
          <Button @click="planDrawer.visible=false">取 消</Button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script type="text/jsx">
import Vue from 'vue';

import api from '@/api'
import mixin from '@/libs/mixins/Index'

import PlanForm from '@/views/common/plan/components/Form.vue';
Vue.component('plan-form', PlanForm);

export default {
  name: 'aip-common-plan-index',
  mixins:[mixin],
  data () {
    return {
      query:{
        plateNo: '',
        box: '',
        goodsName: '',
        gate: '',
        channel: '',
        creator:'',
        createTime:''
      },
      page:{
        size: 10,
        current: 1,
        total: 0,
        sort: "id_desc",
        loading:false,
        data:[]
      },
      list:{
        data:[]
      },
      planDrawer:{
        action:'add',
        visible: false,
        submiting:false
      },
      batchOperate:{
        action:'',
        submiting:false,
        options:[
          {value:'handleBatchRemove',label:'批量删除'}
        ]
      }
    }
  },
  created(){
    this.handleList()
  },
  methods: {
    setTimeFormat(str, date){
      console.log(str)
      var datetime =  new Date(str);
      this.query.createTime = str;
    },
    handleList(){
      this.list.loading = true;
      api.common.Plan.userList()
        .then(data=>{
          this.list.data = data;
          this.list.loading=false;
        }).catch(error=> this.list.loading = false)
    },
    handleBatchOperate(){
      let records = this.$refs.planTable.getSelection()
      if (records.length == 0) {
        this.$Message.warning(this.$t('errorText'))
        return;
      }
      this[this.batchOperate.action](records)
    },
    handleSearch(){
      this.page.loading = true;
      api.common.Plan.query(this.query,this.page)
        .then(data=>{
          this.page =  Object.assign(this.page,data);
          this.page.loading = false;
        }).catch(error=> this.page.loading = false)
    },
    openPlanDrawer(plan){
      this.planDrawer.visible = true
      this.planDrawer.type = plan ? plan.type : 'add'
      this.$nextTick(()=>{
        if(plan){
          this.$refs['planForm'].getPlan(plan.id,plan.type)
        }else{
          this.$refs['planForm'].handleReset()
        }
      })
    },
    handleSubmit(){
      this.planDrawer.submiting = true;
      this.$refs.planForm.handleSubmit(
        data=>{
          this.planDrawer.submiting = false;
          this.handleSearch();
          setTimeout(() => this.planDrawer.visible=false, 1000);
        },
        ()=>{
          this.planDrawer.submiting = false;
        }
      )
    },
    deletePlan(id){
      api.common.Plan.remove(id)
        .then(response=> {
          this.$Message.success(this.$t('successText'))
          this.handleSearch()
        }).catch(error=> console.log(error))
    },
    handleBatchRemove(rows){
      this.batchOperate.submiting = true
      Promise.all(rows.map(item=>api.common.Plan.remove(item.id)))
        .then(res => {
          this.batchOperate.submiting = false;
          this.handleSearch()
        }).catch(e=> {
        this.batchOperate.submiting = false
        this.handleSearch()
      })
    }
  },
  computed: {
    columns () {
      return [
        {key: 'id', width: 60, fixed:'left',type:'selection'},
        {key: 'plateNo', align:'left',minWidth: 120,fixed:'left', title:  this.$t('common.plan.plateNo.label')},
        {key: 'box', align:'left',minWidth: 120, title:  this.$t('common.plan.box.label')},
        {key: 'goodsName', align:'left',minWidth: 120, title:  this.$t('common.plan.goodsName.label')},
        {key: 'tonnage', align:'left',minWidth: 120, title: "货物吨数"},
        {key: 'cscpUser', align:'left',minWidth: 120, title: "创建人",
          render: (h,params) => {
           //console.log(params.row.cscpUser.username)
            if (params.row.cscpUser==null){
              return <span>{}</span>
            }
            return <span>{params.row.cscpUser.username}</span>
          }
        },
        /*{key: 'gate', align:'left',minWidth: 120, title:  this.$t('common.plan.gate.label')},*/
        {key: 'channel', align:'left',minWidth: 120, title:  this.$t('common.plan.channel.label')},
        {key: 'crossTime', align: 'center', width:170, title: this.$t('common.plan.crossTime.label')},
        {key: 'type', align: 'center', width: 120, title: this.$t('common.plan.type.label'),
          render: (h, params) => {
            return  <div>{
              this.$t('common.plan.type.dictionary').map(item => {
                if (item.value==params.row.type){
                  return <span>{ item.label }</span>
                }
              })
            }
            </div>
          }
        },
        {
          key: 'status',
          align: 'center',
          width: 120,

          title: this.$t('common.plan.status.label'),

          render: (h, params) => {
            let status = {
              "status": params.row.status
            }
            return <div>
              {
                this.$t('common.plan.status.dictionary').map(item => {
                  if (item.value==params.row.status){
                    if (item.label=="未用"){
                      return <Button type="primary">未用</Button>
                    }else {
                      return <Button>已用</Button>
                    }

                  }
                })
              }
            </div>
          }
        },
        {key: 'createTime', align: 'center', width:170, title: this.$t('common.plan.createTime.label')},
        {
          title: this.$t('operateText'),
          align: 'center',
          width: 140,
          fixed:"right",
          key: 'handle',
          render: (h, params)=>{
            return <div style="display: flex;justify-content: space-around;">
              <a href="javascript:void(0);" onClick={()=>this.openPlanDrawer({ id: params.row.id ,type:'detail'})}>{this.$t('detailText')}</a>
              <a href="javascript:void(0);" onClick={()=>this.openPlanDrawer({ id: params.row.id ,type:'edit' })}>{this.$t('editText')}</a>
              <Poptip confirm={true} title={this.$t('deletePopTip')} transfer={true}
                      onOn-ok={()=>this.deletePlan(params.row.id)}>
                <a href="javascript:void(0);">{this.$t('deleteText')}</a>
              </Poptip>
            </div>
          }
        }
      ]
    }
  }
}
</script>
